
import React from 'react';
import { FacilityOrderNewFlowExtraSuppliesAddModalTemplate } from 'themes/application/facility-order-new-flow-inventory/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowExtraSuppliesAddModalViewStore } from 'application/facility-order-new-flow-inventory/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowExtraSuppliesAddModalViewStore(rootStore, componentProps), 'facilityOrderNewFlowExtraSuppliesAddModalViewStore')
@observer
class FacilityOrderNewFlowExtraSuppliesAddModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowExtraSuppliesAddModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowExtraSuppliesAddModal;
